<template>
  <ts-loading-banner :loading="loading">
    <div class="ts-flex ts-flex-col ts-space-y-2">
      <div class="row">
        <div class="col-md-12">
          <label class="required">{{
            $t('paymentNotice.studentNameKh')
          }}</label>
          <div
            class="ts-grid ts-grid-cols-2 ts-gap-2 ts-border ts-border-dashed ts-border-gray-500 ts-p-2 ts-rounded-md"
          >
            <div>
              <a-input
                class="ts-w-full"
                :placeholder="$t('paymentNotice.firstName')"
                v-model="model.first_name_kh"
              ></a-input>
              <div class="ts-text-red-500" v-if="errors.has('first_name_kh')">
                {{ errors.first('first_name_kh') }}
              </div>
            </div>
            <div>
              <a-input
                class="ts-w-full"
                v-model="model.last_name_kh"
                :placeholder="$t('paymentNotice.lastName')"
              ></a-input>
              <div class="ts-text-red-500" v-if="errors.has('last_name_kh')">
                {{ errors.first('last_name_kh') }}
              </div>
            </div>
            <input
              type="text"
              class="form-control ts-col-span-2"
              :placeholder="$t('paymentNotice.fullName')"
              :value="fullNameKh"
              readonly
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required">{{
            $t('paymentNotice.studentNameEn')
          }}</label>
          <div
            class="ts-grid ts-grid-cols-2 ts-gap-2 ts-border ts-border-dashed ts-border-gray-500 ts-p-2 ts-rounded-md"
          >
            <div>
              <a-input
                class="ts-w-full"
                :placeholder="$t('paymentNotice.firstName')"
                v-model="model.first_name_en"
              ></a-input>
              <div class="ts-text-red-500" v-if="errors.has('first_name_en')">
                {{ errors.first('first_name_en') }}
              </div>
            </div>
            <div>
              <a-input
                class="ts-w-full"
                v-model="model.last_name_en"
                :placeholder="$t('paymentNotice.lastName')"
              ></a-input>
              <div class="ts-text-red-500" v-if="errors.has('last_name_en')">
                {{ errors.first('last_name_en') }}
              </div>
            </div>
            <input
              type="text"
              class="form-control ts-col-span-2"
              :placeholder="$t('paymentNotice.fullName')"
              :value="fullNameEn"
              readonly
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="ts-flex ts-space-x-3">
            <div
              class="ts-border ts-border-gray-400 ts-rounded-md ts-px-3 ts-py-1"
            >
              <div class="radio radio-css radio-inline">
                <input
                  type="radio"
                  id="male"
                  v-model="model.gender"
                  value="Male"
                  :class="{
                    'is-invalid': errors.has('gender')
                  }"
                />
                <label for="male">Male</label>
              </div>
              <div class="radio radio-css radio-inline">
                <input
                  type="radio"
                  id="female"
                  v-model="model.gender"
                  value="Female"
                  :class="{
                    'is-invalid': errors.has('gender')
                  }"
                />
                <label for="female">Female</label>
              </div>
              <div class="invalid-feedback" v-if="errors.has('gender')">
                {{ errors.first('gender') }}
              </div>
            </div>
            <div
              class="ts-border ts-border-gray-400 ts-rounded-md ts-px-3 ts-py-1 ts-flex ts-space-x-2"
            >
              <ts-checkbox
                v-model="model.is_student"
                @change="() => (model.is_external_candidate = false)"
                >{{ $t('paymentNotice.isStudent') }}</ts-checkbox
              >
              <ts-checkbox
                v-model="model.is_external_candidate"
                @change="() => (model.is_student = false)"
                >{{ $t('paymentNotice.externalCanditdate') }}</ts-checkbox
              >
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required">{{ $t('paymentNotice.batch') }}</label>
          <a-input type="number" v-model="model.promotion" min="1"></a-input>
          <div class="ts-text-red-500" v-if="errors.has('promotion')">
            {{ errors.first('promotion') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required">{{ $t('paymentNotice.department') }}</label>
          <a-select
            v-model="model.acp_id"
            :options="mainProgramList"
            class="ts-w-full"
            showSearch
            optionFilterProp="children"
            :filterOption="filterOption"
            @change="onMainProgramChange"
          ></a-select>
          <div class="ts-text-red-500" v-if="errors.has('acp_id')">
            {{ errors.first('acp_id') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required">{{ $t('paymentNotice.major') }}</label>
          <a-select
            v-model="model.acps_id"
            :options="sub_programs"
            class="ts-w-full"
            showSearch
            optionFilterProp="children"
            :filterOption="filterOption"
            @change="fetchLevel"
          ></a-select>
          <div class="ts-text-red-500" v-if="errors.has('acps_id')">
            {{ errors.first('acps_id') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required">{{ $t('paymentNotice.degree') }}</label>
          <a-select
            v-model="model.level_id"
            :options="levels"
            class="ts-w-full"
            mode="multiple"
            showSearch
            optionFilterProp="children"
            :filterOption="filterOption"
          ></a-select>
          <div class="ts-text-red-500" v-if="errors.has('level_id')">
            {{ errors.first('level_id') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div
            class="ts-border ts-border-dashed ts-border-gray-500 ts-p-2 ts-rounded-md ts-space-y-2"
          >
            <div class="ts-flex ts-items-center ts-space-x-3">
              <ts-checkbox v-model="model.is_card_discount">{{
                $t('paymentNotice.discountCard')
              }}</ts-checkbox>
              <ts-checkbox
                v-model="model.is_till_further_notice"
                @change="onFeatureNoticeChange"
                >{{ $t('paymentNotice.untilFeatureNotice') }}</ts-checkbox
              >
            </div>
            <div class="row">
              <div class="col-md-12">
                <label :class="{ required: model.is_card_discount }">{{
                  $t('paymentNotice.discountRate')
                }}</label>
                <a-input
                  type="number"
                  v-model="model.card_discount_rate"
                  :disabled="!model.is_card_discount"
                ></a-input>
                <div
                  class="ts-text-red-500"
                  v-if="errors.has('card_discount_rate')"
                >
                  {{ errors.first('card_discount_rate') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label
                  :class="{
                    required:
                      !model.is_till_further_notice && model.is_card_discount
                  }"
                  >{{ $t('paymentNotice.discountExpireDate') }}</label
                >
                <a-date-picker
                  v-model="model.discount_expiry_date"
                  valueFormat="DD-MM-YYYY"
                  format="DD-MM-YYYY"
                  class="ts-w-full"
                  :disabled="
                    model.is_till_further_notice || !model.is_card_discount
                  "
                ></a-date-picker>
                <div
                  class="ts-text-red-500"
                  v-if="errors.has('discount_expiry_date')"
                >
                  {{ errors.first('discount_expiry_date') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label>{{ $t('paymentNotice.discountNote') }}</label>
                <textarea
                  class="form-control"
                  rows="2"
                  v-model="model.discount_note"
                  :disabled="!model.is_card_discount"
                ></textarea>
              </div>
            </div>
            <div class="row" v-if="model.is_card_discount">
              <div class="col-md-12">
                <div
                  class="ts-h-40 ts-bg-gray-200 ts-p-2 ts-cursor-pointer ts-rounded-md ts-relative"
                  @click="onClickBrowse"
                >
                  <div class="ts-text-center" v-if="!imageSrc">
                    <i
                      class="far fa-image fa-2x ts-py-2 ts-px-2 ts-bg-blue-100 ts-text-blue-500 ts-rounded-full"
                    ></i>
                    <h2 class="ts-text-lg ts-font-semibold ts-text-gray-500">
                      Click here to browse file
                    </h2>
                  </div>
                  <img
                    v-else
                    :src="imageSrc"
                    alt=""
                    class="ts-w-full ts-h-full ts-rounded-md ts-object-contain"
                  />
                  <button
                    v-if="imageSrc"
                    class="ts-w-6 ts-h-6 ts-flex ts-items-center ts-justify-center ts-bg-red-500 ts-rounded-full ts-text-white ts-absolute ts-top-0 ts-right-0 ts-mt-2 ts-mr-2 z-10 hover:ts-bg-red-600 ts-transition-colors focus:ts-outline-none"
                    @click.stop="removeImage"
                    title="Remove image"
                  >
                    <i class="fas fa-times ts-text-xs"></i>
                  </button>
                </div>
                <input
                  type="file"
                  ref="discount_card_image"
                  class="ts-hidden"
                  accept="image/*"
                  @change="onFileChange"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <ts-button @click="onSave" color="primary" class="ts-w-full">{{
            $t('save')
          }}</ts-button>
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapMutations, mapState } from 'vuex'
import Compressor from 'compressorjs'
export default {
  name: 'formCreateNewStudent',
  data() {
    return {
      errors: new Errors(),
      loading: false,
      sub_programs: [],
      levels: [],
      model: {
        first_name_kh: undefined,
        last_name_kh: undefined,
        first_name_en: undefined,
        last_name_en: undefined,
        gender: undefined,
        is_student: true,
        promotion: undefined,
        acp_id: undefined,
        acps_id: undefined,
        level_id: undefined,
        is_card_discount: false,
        is_till_further_notice: false,
        card_discount_rate: undefined,
        discount_expiry_date: undefined,
        discount_note: undefined,
        cpp_id: undefined,
        discount_card_images: undefined,
        is_external_candidate: false
      }
    }
  },
  mounted() {
    this.fetchMainProgram()
  },
  computed: {
    ...mapState('studentProfile', ['main_programs']),
    mainProgramList() {
      return this.main_programs.map(el => ({
        value: el.acp_id,
        label: el.acp_name_foreign
      }))
    },
    fullNameKh() {
      return (
        (this.model.first_name_kh ? this.model.first_name_kh : '') +
        (this.model.last_name_kh ? ' ' + this.model.last_name_kh : '')
      )
    },
    fullNameEn() {
      return (
        (this.model.first_name_en ? this.model.first_name_en : '') +
        (this.model.last_name_en ? ' ' + this.model.last_name_en : '')
      )
    },
    imageSrc() {
      const image = this.model.discount_card_images
      if (!image) return null

      // If it's a File (e.g., uploaded from input)
      if (image instanceof File) {
        return URL.createObjectURL(image)
      }

      // If it's already a URL string
      if (typeof image === 'string') {
        return image
      }

      return null
    }
  },
  methods: {
    ...mapActions('paymentNoticeModule', ['onSaveNewStudent']),
    ...mapActions('studentProfile', ['getMainProgram', 'getSubProgram']),
    ...mapMutations('paymentNoticeModule', ['SET_SELECTED_STUDENT']),
    fetchMainProgram() {
      this.loading = true
      this.getMainProgram().finally(() => (this.loading = false))
    },
    onMainProgramChange(acp_id) {
      this.model.acps_id = null
      this.sub_programs = []
      this.model.level_id = []
      this.levels = []
      this.loading = true
      this.$store
        .dispatch('studentProfile/getSubProgramByMain', { acp_id: acp_id })
        .then(response => {
          this.sub_programs = response.data.map(el => ({
            value: el.acps_id,
            label: el.acps_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    fetchLevel(acps_id) {
      this.model.level_id = undefined
      this.levels = []
      if (acps_id) {
        this.loading = true
        this.$store
          .dispatch('studentProfile/getLevel', { acps_id: acps_id })
          .then(response => {
            this.levels = response.data.map(el => ({
              value: el.level_id,
              label: el.level_name_foreign
            }))
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    onClickBrowse() {
      this.$refs.discount_card_image.click()
    },
    onFileChange(event) {
      const file = event.target.files[0]
      if (file) {
        this.model.discount_card_images = file
      }
    },
    removeImage() {
      this.model.discount_card_images = undefined
    },
    onFeatureNoticeChange() {
      this.model.discount_expiry_date = undefined
    },
    onDiscountCardChange() {
      this.model.card_discount_rate = undefined
      this.model.discount_expiry_date = undefined
      this.model.discount_note = ''
      this.model.discount_card_images = undefined
    },
    clearInput() {
      this.model.first_name_kh = undefined
      this.model.last_name_kh = undefined
      this.model.first_name_en = undefined
      this.model.last_name_en = undefined
      this.model.gender = undefined
      this.model.is_student = true
      this.model.promotion = undefined
      this.model.acp_id = undefined
      this.model.acps_id = undefined
      this.model.level_id = undefined
      this.model.is_card_discount = false
      this.model.is_till_further_notice = false
      this.model.card_discount_rate = undefined
      this.model.discount_expiry_date = undefined
      this.model.discount_note = undefined
      this.model.cpp_id = undefined
      this.model.discount_card_images = undefined
      this.model.is_external_candidate = false
    },
    async onSave() {
      this.loading = true
      const modelClone = Object.assign({}, this.model)
      const { discount_card_images } = await this.onCompressImage()

      if (discount_card_images) {
        let formData = new FormData()
        formData.append('photo', discount_card_images)
        let photo_path = await this.$store.dispatch(
          'studentProfile/uploadPhoto',
          formData
        )
        modelClone.discount_card_images = photo_path
      }

      this.onSaveNewStudent(modelClone)
        .then(({ data }) => {
          this.SET_SELECTED_STUDENT(data.student)
          this.$emit('student-saved', data.student)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.response.data.message)
          this.errors = new Errors(error.response.data.errors)
        })
        .finally(() => (this.loading = false))
    },
    async onCompressImage() {
      const compres = {
        discount_card_images: undefined
      }

      if (
        this.model.discount_card_images instanceof File ||
        this.model.discount_card_images instanceof Blob
      ) {
        compres.discount_card_images = await new Promise(resolved => {
          new Compressor(this.model.discount_card_images, {
            quality: 0.2,
            success: result => resolved(result)
          })
        })
      }

      return compres
    }
  }
}
</script>
